export default "__VITE_ASSET__BLA905Ga__"